// extracted by mini-css-extract-plugin
export default {"header":"profile_header__4xBpo","whiteContainer":"profile_whiteContainer__DlWfT"};